/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { MODELS } from '../../../../../Apis/Models';
import { TABLES } from '../../../../../Apis/Tables';
import { clearSearchFilters } from '../../../../../reduxToolkit/Search/SearchSlice';
import { DeleteItemsApi } from '../../../../../reduxToolkit/Commons/CommonsApi';
import { VIEW_TYPE } from '../../../../../enums/ViewType';
import {errorMsg} from "../../../../../Apis/functions";
import {CommonDocumentationApp} from "../../../Contractors/CompanyDocumentation/Functionality/CommonDocumentationApp";

const AllVehiclesApp = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { getUserFullInformation } = useSelector((state) => state.CommonsSlice);
    const [view, setView] = useState(VIEW_TYPE.LIST.name);
    const [selectedList, setSelectedList] = useState([]);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [deleteVehicleShow, setDeleteVehicleShow] = useState(false);
    const [filterDialogShow, setFilterDialogShow] = useState(false);
    const [finalArray, setFinalArray] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [importFileShow, setImportFileShow] = useState(false);
    const [creationErrorsShow, setCreationErrorsShow] = useState(false);
    const [searchElement, setSearchElement] = useState('');
    const [bodyForExport, setBodyForExport] = useState('');
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [modified, setModified] = useState(false);
    const [search, setSearch] = useState(false);
    let moduleId;
    let option;
    const [criteria, setCriteria] = useState();

    if (contractorId !== null) {
        moduleId = `${MODELS.ContractorVehicle}`;
        option = `${TABLES.CONTRACTOR_VEHICLE}`;
    } else if (supplierId !== null) {
        moduleId = `${MODELS.SupplierVehicle}`;
        option = `${TABLES.SUPPLIER_VEHICLE}`;
    } else {
        // Props to the filter window
        moduleId = `${MODELS.vehicle}`;
        option = `${TABLES.VEHICLES}`;
    }

    const [showActionsContractorSupplier, setShowActionsContractorSupplier] = useState(false);
    const { isActiveContractorSupplier } = CommonDocumentationApp();

    useEffect(() => {
        if(getUserFullInformation?.statusId){
            setShowActionsContractorSupplier(isActiveContractorSupplier(getUserFullInformation?.statusId));
        }
    }, [getUserFullInformation]);

    // useEffect to avoid first load
    useEffect(() => {
        sessionStorage.removeItem('contractId');
        sessionStorage.removeItem('supplier_order_id');
        return () => {
            dispatch(clearSearchFilters());
        };
    }, []);

    // Function to delete selected vehicles
    const deleteSelectedVehicles = (deleteItem) => {
        const tableName = contractorId ? TABLES.CONTRACTOR_VEHICLE : supplierId ? TABLES.SUPPLIER_VEHICLE :  TABLES.VEHICLES;
        const body = deleteItem;

        if (body.length > 0) {
            dispatch(DeleteItemsApi({ tableName, body })).then(
                ({
                    payload: {
                        data: { success, code },
                    },
                }) => {
                    if (success === true) {
                        setSelectedList([]);
                        setIsAllChecked(false);
                        setModified(true);
                    }else errorMsg(code);
                }
            );
        }
    };

    return {
        deleteSelectedVehicles,
        contractorId,
        supplierId,
        permission,
        t,
        DEV,
        option,
        moduleId,
        criteria,
        setCriteria,
        view,
        setView,
        selectedList,
        setSelectedList,
        deleteVehicleShow,
        setDeleteVehicleShow,
        filterDialogShow,
        setFilterDialogShow,
        finalArray,
        setFinalArray,
        setLoaded,
        importFileShow,
        setImportFileShow,
        setCreationErrorsShow,
        searchElement,
        setSearchElement,
        bodyForExport,
        setBodyForExport,
        setSimpleSearch,
        search,
        setSearch,
        modified,
        setModified,
        isAllChecked,
        setIsAllChecked,
        showActionsContractorSupplier
    };

};

export default AllVehiclesApp;
